<div class="py-4 d-flex justify-content-between align-items-center" [dataSelector]="dataSelector + '-header'">
  <h4 class="h4-500 color-gray-100 m-0" [dataSelector]="dataSelector + '-title'">Upload files</h4>
  <div *ngIf="((stagedFileDisplays$ | async)?.length + (uncategorizedFileDisplays$ | async)?.length + (categorizedFileDisplays$ | async)?.length)>0"
    class="file-counter" [dataSelector]="dataSelector + '-file-counter'">
    {{ (stagedFileDisplays$ | async)?.length + (uncategorizedFileDisplays$ | async)?.length + (categorizedFileDisplays$ | async)?.length }} uploaded
  </div>
</div>

@if(isEditable$ | async) {
  <div class="py-4" [dataSelector]="dataSelector + '-upload-section'">
    <awn-upload-files
      [accept]="acceptedFileTypes"
      [entityId]="jobId$ | async"
      (onFileUploadStart)="onUploadFilesStart($event)"
      (onFileUploadEnd)="onUploadFilesComplete($event)"
      [dataSelector]="dataSelector + '-upload-component'"
    ></awn-upload-files>
  </div>
}

<ng-container *ngIf="haveFilesBeenUploaded$ | async; else noFilesUploadedTemplate">
  <!-- filters section -->
  <div class="py-2" [dataSelector]="dataSelector + '-filter-section'">
    @if(isFileFlaggingEnabled()) {
      <!-- Radio button filters when file flagging is enabled -->
      <div class="d-flex flex-column gap-2">
        <label class="d-flex align-items-center">
          <input
            type="radio"
            name="fileFilter"
            [value]="FileFilterOption.ALL"
            [checked]="selectedFilter() === FileFilterOption.ALL"
            (change)="onFilterChange(FileFilterOption.ALL)"
            [dataSelector]="dataSelector + '-filter-all-radio'"
            class="document-upload-tab__filter-radio">
          <span>Show All</span>
          <pill
            color="blue"
            size="small"
            [value]="allFilesCount()"
            class="document-upload-tab__filter-pill"
            [dataSelector]="dataSelector + '-all-count-pill'">
          </pill>
        </label>

        <label class="d-flex align-items-center">
          <input
            type="radio"
            name="fileFilter"
            [value]="FileFilterOption.UNCATEGORIZED"
            [checked]="selectedFilter() === FileFilterOption.UNCATEGORIZED"
            (change)="onFilterChange(FileFilterOption.UNCATEGORIZED)"
            [dataSelector]="dataSelector + '-filter-uncategorized-radio'"
            class="document-upload-tab__filter-radio">
          <span>Show Only Uncategorized</span>
          <pill
            color="red"
            size="small"
            [value]="uncategorizedCount()"
            class="document-upload-tab__filter-pill"
            [dataSelector]="dataSelector + '-uncategorized-count-pill'">
          </pill>
        </label>

        <label class="d-flex align-items-center">
          <input
            type="radio"
            name="fileFilter"
            [value]="FileFilterOption.FLAGGED"
            [checked]="selectedFilter() === FileFilterOption.FLAGGED"
            (change)="onFilterChange(FileFilterOption.FLAGGED)"
            [dataSelector]="dataSelector + '-filter-flagged-radio'"
            class="document-upload-tab__filter-radio">
          <span>Show Only Flagged</span>
          <pill
            color="red"
            size="small"
            [value]="flaggedCount()"
            class="document-upload-tab__filter-pill"
            [dataSelector]="dataSelector + '-flagged-count-pill'">
          </pill>
        </label>
      </div>
    } @else {
      <div class="d-flex align-items-center">
        <mat-checkbox
          (change)="toggleUncategorizedFilter($event)"
          class="filter-checkbox"
          [dataSelector]="dataSelector + '-filter-checkbox'"
        >
          Show only uncategorized files
        </mat-checkbox>
        <pill
          color="red"
          size="small"
          [value]="(uncategorizedFileDisplays$ | async)?.length"
          class="document-upload-tab__uncategorized-pill"
          [dataSelector]="dataSelector + '-uncategorized-count-pill'"
        ></pill>
      </div>
    }
  </div>

  <!-- Staged file displays - only shown when not filtering -->
  @if (!(showOnlyUncategorized())) {
    @for(stagedFile of stagedFileDisplays$ | async; track stagedFile) {
      @if(stagedFile.dmsUploadFileJobId) {
        <awn-file-upload-job-item [jobId]="stagedFile.dmsUploadFileJobId" [compact]="true"/>
      }
    }
  }

  <!-- Uncategorized displays -->
  <ng-container #uncategorizedFileDisplays *ngIf="shouldShowUncategorizedFiles()">
    @let uncategorizedFiles = uncategorizedFileDisplays$ | async;
    <div *ngFor="let uncategorizedFileDisplay of uncategorizedFiles; let i = index"
         class="client-request-submission-file-display"
         [dataSelector]="dataSelector + '-uncategorized-file-' + i">
      <div class="container-icon">
        <awn-file-item-icon [fileName]="uncategorizedFileDisplay.name"></awn-file-item-icon>
      </div>
      <div class="container-content">
        <p [dataSelector]="dataSelector + '-uncategorized-file-name-' + i" tooltipOverflow position="above">{{ uncategorizedFileDisplay.name }}</p>
      </div>
      <div class="container-actions">
        <button
          andButton
          color="ghost"
          size="small"
          [showMenuIcon]="false"
          [matMenuTriggerFor]="menu"
          [dataSelector]="dataSelector + '-uncategorized-file-menu-button-' + i"
        >
          <aiwyn-icon name="more-horizontal" [height]="16" [width]="16"></aiwyn-icon>
        </button>
      </div>

      <mat-menu
        #menu="matMenu"
        xPosition="before"
        class="document-file-chip-menu"
      >
        @if(isEditable$ | async) {
          <div mat-menu-item (click)="linkToRequests(uncategorizedFileDisplay)" [dataSelector]="dataSelector + '-uncategorized-file-link-option-' + i">
            <p>Link to requests</p>
            <aiwyn-icon name="copy" [height]="16" [width]="16"></aiwyn-icon>
          </div>
        }

        <div mat-menu-item (click)="previewFile(uncategorizedFiles, uncategorizedFileDisplay)" [dataSelector]="dataSelector + '-uncategorized-file-preview-option-' + i">
          <p>Preview File...</p>
          <aiwyn-icon name="search" [height]="16" [width]="16"></aiwyn-icon>
        </div>

        @if(isEditable$ | async) {
          <div
            mat-menu-item
            (click)="deleteFile(uncategorizedFileDisplay)"
            [disabled]="!canDeleteFile(uncategorizedFileDisplay)"
            [tooltip]="getFileDeleteTooltip(uncategorizedFileDisplay)"
            [tooltipEnabled]="!canDeleteFile(uncategorizedFileDisplay)"
            position="below"
            tooltipPanelClass="menu-item-tooltip"
            [dataSelector]="dataSelector + '-uncategorized-file-delete-option-' + i">
            <p>Delete file</p>
            <aiwyn-icon name="trash-2" [height]="16" [width]="16"></aiwyn-icon>
          </div>
        }
      </mat-menu>
    </div>
  </ng-container>

  <!-- Categorized file displays -->
  <ng-container #categorizedFileDisplays *ngIf="shouldShowCategorizedFiles()">
    @let categorizedFiles = (shouldShowOnlyFlaggedCategorized() ? categorizedAndFlaggedFileDisplays$ : categorizedFileDisplays$) | async;
    <div *ngFor="let categorizedFileDisplay of categorizedFiles; let i = index"
         class="client-request-submission-file-display"
         [dataSelector]="dataSelector + '-categorized-file-' + i">
      @if(isFileFlaggingEnabled()) {
        <div class="container-icon">
          <awn-file-item-icon
            *ngIf="categorizedFileDisplay.isFlagged"
            iconName="flag-pennant"
            iconNamespace="phosphor"
            [cssClasses]="['is-flagged','icon-color-red-200', 'icon-fill-red-200']"
            [dataSelector]="dataSelector + '-categorized-file-flag-' + i"
          >
          </awn-file-item-icon>
          <awn-file-item-icon
            *ngIf="!categorizedFileDisplay.isFlagged"
            [fileName]="categorizedFileDisplay.name">
          </awn-file-item-icon>
        </div>
        <div class="container-content">
          <p [dataSelector]="dataSelector + '-categorized-file-name-' + i" tooltipOverflow position="above">{{ categorizedFileDisplay.name }}</p>
        </div>
      } @else {
        <div class="container-icon">
          <awn-file-item-icon [fileName]="categorizedFileDisplay.name"></awn-file-item-icon>
        </div>
        <div class="container-content">
          <p [dataSelector]="dataSelector + '-categorized-file-name-' + i" tooltipOverflow position="above">{{ categorizedFileDisplay.name }}</p>
        </div>
      }

      <div class="container-actions">
        <button
          andButton
          color="ghost"
          size="small"
          [showMenuIcon]="false"
          [matMenuTriggerFor]="menu"
          [disabled]="categorizedFileDisplay.isMasked"
          [ngClass]="{ 'cursor-not-allowed': categorizedFileDisplay.isMasked }"
          tooltip="This file is restricted and cannot be viewed or modified."
          [tooltipEnabled]="categorizedFileDisplay.isMasked"
          [dataSelector]="dataSelector + '-categorized-file-menu-button-' + i"
        >
          <aiwyn-icon name="more-horizontal" [height]="16" [width]="16"></aiwyn-icon>
        </button>
      </div>

      <mat-menu
        #menu="matMenu"
        xPosition="before"
        class="document-file-chip-menu"
      >
        @if(isEditable$ | async) {
          <div mat-menu-item (click)="linkToRequests(categorizedFileDisplay)" [dataSelector]="dataSelector + '-categorized-file-link-option-' + i">
            <p>Link to other requests</p>
            <aiwyn-icon name="copy" [height]="16" [width]="16"></aiwyn-icon>
          </div>
        }

        <div mat-menu-item (click)="previewFile(categorizedFiles, categorizedFileDisplay)" [dataSelector]="dataSelector + '-categorized-file-preview-option-' + i">
          <p>Preview File...</p>
          <aiwyn-icon name="search" [height]="16" [width]="16"></aiwyn-icon>
        </div>

        @if(isEditable$ | async) {
          <div
            mat-menu-item
            (click)="deleteFile(categorizedFileDisplay)"
            [disabled]="!canDeleteFile(categorizedFileDisplay)"
            [tooltip]="getFileDeleteTooltip(categorizedFileDisplay)"
            [tooltipEnabled]="!canDeleteFile(categorizedFileDisplay)"
            position="below"
            tooltipPanelClass="menu-item-tooltip"
            [dataSelector]="dataSelector + '-categorized-file-delete-option-' + i">
            <p>Delete file</p>
            <aiwyn-icon name="trash-2" [height]="16" [width]="16"></aiwyn-icon>
          </div>
        }
      </mat-menu>
    </div>
  </ng-container>
</ng-container>

<ng-template #noFilesUploadedTemplate>
  <div class="d-flex flex-column align-items-center justify-content-center gap-4 flex-grow-1 pt-4 px-6 file-upload-list-zero-state" [dataSelector]="dataSelector + '-no-files-state'">
    <h4 class="h4-500 color-gray-100 text-center" [dataSelector]="dataSelector + '-no-files-title'">No files have been uploaded yet</h4>
    <p class="body-300 color-gray-400 text-center" [dataSelector]="dataSelector + '-no-files-description'">Once you start uploading files to this request, they will be listed here.</p>
  </div>
</ng-template>
